import { Center, Text } from "@chakra-ui/react"
import { PropsWithChildren } from "react"

const NoImage = ({ children }: PropsWithChildren<{}>) => {
    return (
        <Center bg="gray.200" p={2} rounded="xl">
            <Text>{children ?? 'Sem imagem'}</Text>
        </Center>
    )
}
export default NoImage